/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import React from 'react';
import styled from 'styled-components';

import { mediumMediaQuery, smallMediaQuery } from '../../../common/utilities/sizeHelpers';
import { AnimatedLoadingPlaceholder } from '../../common/animatedLoadingPlaceholder/animatedLoadingPlaceholder';

export const KeyIndicatorsLoadingUI = () => {
    return <>
        {Array(...Array(8)).map((x, y) =>  {
            return  <KeyIndicatorItemLoadingIndicator key={y}>
                <LeftSideCirlceLoadingUI>
                    <AnimatedLoadingPlaceholder width={30} height='30px' radius={16} />
                </LeftSideCirlceLoadingUI>
                <BarLoadingUI>
                    <AnimatedLoadingPlaceholder width={120} height={'18px'}/>
                </BarLoadingUI>
                <RightSideCircleLoadingUI>
                    <AnimatedLoadingPlaceholder width={30} height='30px' radius={16} />
                </RightSideCircleLoadingUI>
            </KeyIndicatorItemLoadingIndicator>;}
        )}
    </>;
};

const KeyIndicatorItemLoadingIndicator = styled.div`
    display: flex;
    flex-direction: row;
    width: 100%;
    border-bottom: 1px solid #EEEEEE;
`;

const LeftSideCirlceLoadingUI = styled.div`
    padding: 8px 0 8px 10px;

    @media ${mediumMediaQuery} {
        padding-top: 7px;
    }

    @media ${smallMediaQuery} {
        padding-top: 6px;
    }
`;

const BarLoadingUI = styled.div`
    padding: 14px 0 8px 15px;

    @media ${mediumMediaQuery} {
        padding-top: 13px;
    }
`;

const RightSideCircleLoadingUI = styled.div`
    margin: 0 0 0 auto;
    padding: 8px 15px 8px 0;

    @media ${mediumMediaQuery} {
        padding-top: 7px;
    }

    @media ${smallMediaQuery} {
        padding-top: 6px;
    }
`;
